import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./emailLogAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchAll = createAsyncThunk(
  "emailLog/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);



export const emailLogSlice = createSlice({
  name: "emailLog",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      
  },
});

export const { resetData, setSelected } = emailLogSlice.actions;

export const selectData = (state) => state.emailLog.data;
export const selectLoading = (state) => state.emailLog.loading;
export const selectError = (state) => state.emailLog.error;
export const selectPageNo = (state) => state.emailLog.pageNo;
export const selectPageSize = (state) => state.emailLog.pageSize;
export const selectTotalRecord = (state) => state.emailLog.totalRecord;
export const selectSelected = (state) => state.emailLog.selected;
export const selectResult = (state) => state.emailLog.result;

export default emailLogSlice.reducer;
